import styled from "styled-components"

export const StyledMcpAuditLog = styled.div`
  color: var(--cms-text-primary, #0f172a);

  h2,
  h3 {
    margin: 0 0 12px;
    color: var(--cms-text-primary, #0f172a);
  }

  .filters-section {
    margin-bottom: 20px;
  }

  .results-summary {
    margin-bottom: 12px;
    color: var(--cms-text-secondary, #475569);
    font-size: 14px;
  }

  .audit-table-section {
    overflow-x: auto;
    border: 1px solid var(--cms-border, #dde6f3);
    border-radius: 8px;
    background: var(--cms-surface-secondary, #fff);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  }

  .audit-table {
    width: 100%;
    border-collapse: collapse;
    background: var(--cms-surface-secondary, #fff);
    color: var(--cms-text-primary, #0f172a);

    thead {
      background-color: var(--cms-surface-muted, #f5f5f5);
      border-bottom: 2px solid var(--cms-border, #ddd);
    }

    th {
      padding: 12px;
      text-align: left;
      font-weight: 600;
      white-space: nowrap;
    }

    td {
      padding: 12px;
      border-bottom: 1px solid var(--cms-border, #eee);
      vertical-align: middle;
    }

    td,
    th,
    td strong,
    td code,
    td .operation-code {
      color: var(--cms-text-primary, #0f172a);
    }

    tbody tr {
      background-color: var(--cms-surface-secondary, #fff);
      transition: background-color 0.15s ease;

      &:hover {
        background-color: var(--cms-surface-muted, #f9f9f9);
      }

      &.row-denied {
        background-color: rgba(251, 191, 36, 0.12);

        &:hover {
          background-color: rgba(251, 191, 36, 0.18);
        }
      }
    }

    .cell-user strong {
      color: var(--cms-text-primary, #0f172a);
      font-weight: 600;
    }

    .cell-timestamp {
      font-size: 12px;
      color: var(--cms-text-secondary, #475569);
    }

    .cell-error {
      max-width: 240px;
      font-size: 13px;
      color: #b91c1c !important;
    }

    .operation-code {
      background-color: var(--cms-surface-muted, #f0f0f0);
      color: var(--cms-text-primary, #0f172a);
      padding: 2px 6px;
      border-radius: 3px;
      font-size: 12px;
      border: 1px solid var(--cms-border, #e2e8f0);
    }
  }

  .status-badge {
    display: inline-block;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;

    &.success {
      background-color: var(--cms-success-bg);
      color: #166534 !important;
    }

    &.denied {
      background-color: var(--cms-error-bg);
      color: #9f1239 !important;
    }

    &.failed {
      background-color: var(--cms-error-bg);
      color: #9f1239 !important;
    }

    &.partial {
      background-color: var(--cms-warning-bg);
      color: #92400e !important;
    }
  }

  .empty-state {
    text-align: center;
    padding: 40px;
    color: var(--cms-text-secondary, #475569);
    background: var(--cms-surface-secondary, #fff);

    p:first-child {
      color: var(--cms-text-primary, #0f172a);
      font-weight: 600;
      margin-bottom: 8px;
    }
  }

  .details-row {
    background-color: var(--cms-surface-muted, #fafafa) !important;

    .details-panel {
      display: grid;
      gap: 12px;
      font-size: 13px;
      color: var(--cms-text-primary, #0f172a);

      strong {
        color: var(--cms-text-primary, #0f172a);
      }

      pre {
        margin: 8px 0 0;
        padding: 10px;
        background: var(--cms-surface-secondary, #f0f0f0);
        color: var(--cms-text-primary, #0f172a);
        border: 1px solid var(--cms-border, #e2e8f0);
        border-radius: 4px;
        overflow: auto;
        font-size: 12px;
      }
    }
  }

  [data-cms-theme="dark"] & {
    .audit-table td,
    .audit-table th,
    .audit-table td strong,
    .audit-table td code,
    .audit-table .operation-code,
    .details-panel,
    .details-panel strong {
      color: var(--cms-text-primary) !important;
    }

    .cell-timestamp {
      color: var(--cms-text-secondary) !important;
    }

    .cell-error {
      color: #fca5a5 !important;
    }

    .status-badge.success {
      color: #86efac !important;
    }

    .status-badge.denied,
    .status-badge.failed {
      color: #fda4af !important;
    }

    .status-badge.partial {
      color: #fde68a !important;
    }

    .audit-table tbody tr.row-denied {
      background-color: rgba(251, 191, 36, 0.14);

      &:hover {
        background-color: rgba(251, 191, 36, 0.22);
      }
    }
  }
`
